import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router";

import { InputGroup } from "react-bootstrap";
import { Button } from "react-bootstrap";

import { format } from "date-fns";
import * as XLSX from "xlsx";

import * as Constant from "../../../Constant.js";
import axios from "@app/lib/axios";
import * as commonData from "@app/lib/common_data";
import utility from "@app/lib/utility";

import AgGridReactEx from "@app/components/AgGridReactEx";

const List = () => {
    const history = useHistory();
    const location = useLocation();
    const [serviceAppList, setServiceAppList] = useState(null);
    const [list, setList] = useState(null);
    const [tableData, setTableData] = useState(null);
    const [searchParam, setSearchParam] = useState({
        type: location.state && location.state.searchParam ? location.state.searchParam.type || "join" : "join",
        value: location.state && location.state.searchParam ? location.state.searchParam.value || "" : "",
    });
    const [adjustmenting, setAdjustmenting] = useState(false);

    useEffect(() => {
        if (!serviceAppList) {
            commonData.getServiceAppList(axios, (err, list) => {
                if (!err) {
                    setServiceAppList(list);
                }
            });
        }
        return () => {};
    }, []);

    useEffect(() => {
        if (serviceAppList) {
            if (location.state) {
                location.state = null;
            }
            getBranchList();
        }
        return () => {};
    }, [serviceAppList]);

    const getBranchList = () => {
        setList(null);
        setTableData(null);
        axios({
            method: "get",
            url: `${Constant.API_DOMAIN}/api/branch/list`,
        })
            .then((res) => {
                res.data.branches.forEach((b) => {
                    b.serviceApps = getCanContractAppList(b.apps);
                });
                setList(res.data.branches);
                applyData(searchParam, res.data.branches);
            })
            .catch((error) => {
                console.log(error);
                setList(null);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };
    const getCanContractAppList = (apps) => {
        const value = apps ? apps.split(",") : [];
        let result = [];
        if (serviceAppList) {
            serviceAppList.forEach((sa) => {
                const serviceApp = value.find((a) => sa.key == a);
                if (serviceApp) {
                    result.push(sa.name);
                }
            });
        }
        return result.join(",");
    };
    const listColumn = [
        {
            headerName: "No",
            headerClass: "bg-dark text-light",
            field: "no",
            sortable: false,
            width: 50,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            valueGetter: "node.rowIndex + 1",
        },
        {
            headerName: "지사명",
            headerClass: "bg-dark text-light",
            field: "name",
            width: 100,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "지사장명",
            headerClass: "bg-dark text-light",
            field: "rep",
            width: 100,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "코드",
            headerClass: "bg-dark text-light",
            field: "code",
            width: 60,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "주소",
            headerClass: "bg-dark text-light",
            field: "address",
            width: 120,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "상태",
            headerClass: "bg-dark text-light",
            field: "status",
            width: 80,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (params) => {
                switch (params.value) {
                    case "terminate":
                        return "해지";
                        break;
                    case "join":
                        return "계약";
                        break;
                    default:
                        return "-";
                        break;
                }
            },
        },
        {
            headerName: "계약 권한",
            headerClass: "bg-dark text-light",
            field: "serviceApps",
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "영업 담당자",
            headerClass: "bg-dark text-light",
            field: "biz_rep",
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "계약원",
            headerClass: "bg-dark text-light",
            field: "nursery",
            width: 80,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (params) => {
                return '<button class="btn btn-primary btn-sm font-12" onClick="nurseryPage(' + params.value + ')" style="padding: 1px 3px">바로가기</button>';
            },
        },
        {
            headerName: "등록일",
            headerClass: "bg-dark text-light",
            field: "create_date",
            width: 100,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
    ];
    const onRowClicked = (params) => {
        const historyState = {
            searchParam: { type: searchParam.type, value: searchParam.value },
        };
        history.replace(location.pathname, historyState);
        if (params.api.getFocusedCell().column.getColId() === "nursery") {
            nurseryPage(params.data.id);
        } else {
            detailPage(params.data.id);
        }
    };
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            onSearch();
        }
    };
    const onSearch = () => {
        applyData(searchParam, list);
    };

    const applyData = (searchParam, list) => {
        var tableData = listSearch(searchParam, list);

        setTableData(tableData);
        setSearchParam(searchParam);
    };

    const searchField = ["name", "biz_rep"];
    const listSearch = (searchParam, list) => {
        let tableDataNew = [];
        if (!searchParam.type && !searchParam.value) {
            tableDataNew = list;
        } else {
            list.forEach((item) => {
                searchField.forEach((field) => {
                    if (searchParam.type && item.status !== searchParam.type) {
                        return;
                    }
                    if (!searchParam.value || (item[field] && item[field].indexOf(searchParam.value) >= 0)) {
                        if (tableDataNew.findIndex((d) => d.id == item.id) == -1) {
                            tableDataNew.push(item);
                        }
                    }
                });
            });
        }
        return tableDataNew;
    };

    const nurseryPage = (branchId) => {
        window.location.href = "../../tas/manage/nursery?branch_id=" + branchId;
    };

    const detailPage = (branchId) => {
        window.location.href = "?type=view&id=" + branchId;
    };

    const saveContractTableXlsx = () => {
        if (!tableData || tableData.length === 0) {
            alert("지사 목록이 없습니다.");
            return false;
        }

        const excelHandler = {
            getExcelData() {
                const excelData = {
                    fileName: `지사목록` + "_" + format(new Date(), "yyyyMMddHHmmss") + ".xlsx",
                    sheets: [
                        {
                            name: "지사목록",
                            columnTitle: ["no", "지사명", "지사장명", "코드", "주소", "상태", "계약 권한", "영업 담당자", "등록일"],
                            data: tableData ? tableData.map((s, idx) => [idx + 1, s.name, s.rep, s.code, s.address, s.status == "join" ? "계약" : "해지", getCanContractAppList(s.apps), s.biz_rep, s.create_date]) : [],
                        },
                    ],
                };
                return excelData;
            },
        };
        var wb = XLSX.utils.book_new();
        var excelData = excelHandler.getExcelData();
        excelData.sheets.forEach((s) => {
            var ws = XLSX.utils.aoa_to_sheet([]);
            XLSX.utils.sheet_add_aoa(ws, [excelData.sheets[0].columnTitle], { origin: { r: 0, c: 0 } });
            XLSX.utils.sheet_add_json(ws, s.data, { origin: { r: 1, c: 0 }, skipHeader: true });

            XLSX.utils.book_append_sheet(wb, ws, s.name);
        });

        var wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
        utility.download2Excel(wbout, excelData.fileName);
    };

    const onAdjustmenting = () => {
        setAdjustmenting(true);

        const userType = localStorage.getItem("login_user_type") || "admin";
        const branchId = userType === "branch" ? localStorage.getItem("login_branch_id") || 0 : 0;
        axios({
            method: "get",
            url: `${Constant.API_DOMAIN}/api/branch/${branchId}/adjustment`,
        })
            .then((res) => {
                saveAdjustmentXlsx(res.data.list);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setAdjustmenting(false);
            });
    };

    const saveAdjustmentXlsx = (list) => {
        if (!list || list.length === 0) {
            alert("정산 목록이 없습니다.");
            return false;
        }

        const excelHandler = {
            getExcelData() {
                const excelData = {
                    fileName: `정산목록` + "_" + format(new Date(), "yyyyMMddHHmmss") + ".xlsx",
                    sheets: [
                        {
                            name: "정산목록",
                            columnTitle: [
                                "일자",
                                "순번",
                                "거래처코드",
                                "거래처명",
                                "담당자",
                                "출하창고",
                                "거래유형",
                                "통화",
                                "환율",
                                "비고",
                                "원명",
                                "품목코드",
                                "품목명",
                                "규격",
                                "수량",
                                "단가",
                                "외화금액",
                                "공급가액",
                                "부가세",
                                "적요",
                                "생산전표생성",
                                "원명",
                                "계정",
                                "토모노트 계약 구분",
                                "토모노트 계약 유형\n(클래스/동화결합/한글결합)",
                                "계약기간",
                                "계약승인일"
                            ],
                            data: list
                                ? list.map((s, idx) => [
                                      s.day,
                                      s.bnum,
                                      s.ecAccountCode,
                                      s.bname,
                                      s.charger,
                                      s.storage,
                                      s.tradeType,
                                      s.currency,
                                      s.exchangeRate,
                                      s.description,
                                      s.nurseryName,
                                      s.productCode,
                                      s.productName,
                                      s.standard,
                                      s.productQuantity,
                                      s.productPrice,
                                      s.dolarPrice,
                                      s.sellPrice,
                                      s.tax1,
                                      s.tax2,
                                      s.tax3,
                                      s.uname,
                                      s.userId,
                                      s.tomonoteStatus,
                                      s.tomonoteType,
                                      s.duration,
                                      s.approvalDate
                                  ])
                                : [],
                        },
                    ],
                };
                return excelData;
            },
        };
        var wb = XLSX.utils.book_new();
        var excelData = excelHandler.getExcelData();
        excelData.sheets.forEach((s) => {
            var ws = XLSX.utils.aoa_to_sheet([]);
            XLSX.utils.sheet_add_aoa(ws, [excelData.sheets[0].columnTitle], { origin: { r: 0, c: 0 } });
            XLSX.utils.sheet_add_json(ws, s.data, { origin: { r: 1, c: 0 }, skipHeader: true });

            XLSX.utils.book_append_sheet(wb, ws, s.name);
        });

        var wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
        utility.download2Excel(wbout, excelData.fileName);

        setAdjustmenting(false);
    };

    return (
        <div className="dashboard-wrapper">
            <div className="dashboard-ecommerce">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    <div className="row">
                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                            <div className="page-header">
                                <h2 className="pageheader-title">지사 관리</h2>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                            <button className="btn btn-block btn-primary btn-rounded mb-2" onClick={() => (window.location.href = "?type=create")}>
                                지사 신규 등록
                            </button>
                        </div>
                    </div>
                </div>
                <div className="container-fluid dashboard-content pb-2">
                    <div className="row align-items-end">
                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 pl-4">
                            <h5 className="mb-0" style={{ alignSelf: "end" }}>
                                <span>
                                    {tableData ? tableData.length.toLocaleString() : "0"} / {list ? list.length.toLocaleString() : "0"}
                                </span>
                            </h5>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pb-2 text-right">
                            <button className="btn btn-warning" id="subcontentAdd" type="button" style={{width: 160}} onClick={onAdjustmenting} disabled={adjustmenting}>
                                정산자료 다운로드{adjustmenting ? <span className="fa fa-spinner fa-spin"></span> : <></>}
                            </button>
                        </div>
                        <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 pb-2">
                            <InputGroup className="input-group my-group">
                                <select
                                    className="form-control input-group-append"
                                    title="검색 항목 선택"
                                    style={{ height: "auto", maxWidth: "100px" }}
                                    value={searchParam.type}
                                    onChange={(e) => {
                                        const param = { ...searchParam };
                                        param.type = e.target.value;
                                        setSearchParam(param);
                                        applyData(param, list);
                                    }}
                                >
                                    <option value="" defaultChecked>
                                        전체보기
                                    </option>
                                    <option value="join">계약</option>
                                    <option value="terminate">해지</option>
                                </select>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={searchParam.value}
                                    onChange={(e) => {
                                        const param = { ...searchParam };
                                        param.value = e.target.value;
                                        setSearchParam(param);
                                    }}
                                    onKeyPress={handleKeyPress}
                                />
                                <InputGroup.Append>
                                    <Button className="btn btn-primary" onClick={onSearch}>
                                        검색
                                    </Button>
                                </InputGroup.Append>
                            </InputGroup>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <AgGridReactEx
                                columnDefs={listColumn}
                                rowData={tableData}
                                onRowClicked={onRowClicked}
                                height={550}
                                pagination={true}
                                excelDownload={true}
                                excelDataHandler={saveContractTableXlsx}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default List;
